export default{
    install(Vue){
        Vue.prototype.$inputFocus = function inputFocus(inputClassName) {
				var inputF = $(inputClassName);
				for(var i = 0; i < inputF.length; i++) {
					if($(inputF[i]).val() == '' || $(inputF[i]).val() == null) {
						$(inputF[i]).siblings(".label_focus").removeClass("up");
					} else {
						$(inputF[i]).siblings(".label_focus").addClass("up");
					}
				};
				$(inputF).focus(function() {
					var fn = this;
					if($(fn).val() == '' || $(fn).val() == null) {
						$(fn).siblings(".label_focus").addClass("up");
					} else {
						return
					}
					$(".tip_yz").text("");
				});
				$(inputF).blur(function() {
					var fn = this;
					if($(fn).val() == '' || $(fn).val() == null) {
						$(fn).siblings(".label_focus").removeClass("up")
					} else {
						return
					}
				});
			};
    }
}


// WEBPACK FOOTER //
// ./src/assets/js/inputFocus.js